import React from "react";
import EmiCalculator from "./EmiCalculator";

const LoanEMICalculator = () => {
  return <EmiCalculator amountRequired={true} tenureRequired={true} interestRequired={true} />;
};

export default LoanEMICalculator;
